import { ReloadIcon } from "@radix-ui/react-icons";
import { useEffect, useRef } from "react";
import { Card, CardContent } from "../ui/card";
import style from "./DrinkSelector.module.css";

export default function DrinkLoadingCard({
  setVisible,
  retryAvailable,
  setForceLoad,
}) {
  const loadingElement = useRef<HTMLDivElement>(null);

  const observerRef = useRef(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(([entry]) =>
      setVisible(entry.isIntersecting)
    );
  }, [setVisible]);

  useEffect(() => {
    if (!loadingElement.current) return;
    observerRef.current.observe(loadingElement.current);

    return () => {
      observerRef.current.disconnect();
    };
  }, [loadingElement]);

  return (
    <Card
      style={{
        width: "100%",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "5rem",
      }}
      ref={loadingElement}
    >
      <CardContent
        style={{
          padding: "0.25rem",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          cursor: retryAvailable ? "pointer" : undefined,
          flexDirection: "column",
          gap: "0.5rem",
        }}
        onClick={() => {
          if (!retryAvailable) return;
          setForceLoad(true);
        }}
      >
        <ReloadIcon className={!retryAvailable ? style.spin : undefined} />
        {retryAvailable ? "Zkusit znovu" : "Načítání"}
      </CardContent>
    </Card>
  );
}
